<script>
  export default {
    props: {
      title: {
        type: String,
        default: ''
      },
      list: {
        type: Array,
        default: () => {
          return []
        }
      },
      active: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    data() {
      return {
        value: ''
      }
    },
    watch: {
      active: {
        handler: function( newValue, oldValue) {
          this.value = newValue[0]
        },
        immediate: true,
      }
    },
    methods: {
      onClickTag(tag) {
        this.$emit('click', tag)
        this.value = tag.alias
      },
    }
  }
</script>
<template>
  <div :class="$style.baseKeyword">
    <div v-show="list.length" class="baseKeyword__title">
      {{ title }}
    </div>
    <ul class="baseKeyword__keywordList">
      <li
        v-for="(item, index) in list"
        :key="index"
        class="baseKeyword__keywordList__item"
      >
        <a
          href="javascript:void(0)"
          class="baseKeyword__keywordList__link"
          :class="{ isActive: item.alias === value }"
          @click="onClickTag(item)"
        >
          <el-tag class="isStyleBase">{{ item.title }}</el-tag>
        </a>
      </li>
    </ul>
  </div>
</template>
<style lang="scss" module>
  .baseKeyword {
    :global {
      .baseKeyword {
        &__title {
          margin-bottom: 1.25rem;
          font-size: 1rem;
          font-weight: 500;
          flex-shrink: 0;
        }

        &__keywordList {
          @include list-unstyled;

          margin-bottom: -0.5rem;

          &::after {
            display: block;
            clear: both;
            content: "";
          }

          &__item {
            float: left;
            margin-right: 0.25rem;
            margin-bottom: 0.5rem;
          }

          &__link {
            display: block;
            color: $color-gray-7;

            &.router-link-active {
              color: $color-primary
            }

            &.isActive, &:hover, &:active {
              color: $color-primary;
              text-decoration: none;
              .el-tag {
                color: $color-primary;
              }
            }
          }
        }
      }
    }
  }
</style>
